/**
 * Shared by `TabSidebarLayout`'s legacy sidebar and `DetailsSidebarPanel`. Only one binds it per
 * page — the layout stands down whenever a panel supplies the sidebar — so both cannot fire at once.
 */
export const DETAILS_SIDEBAR_SHORTCUT_LABEL = "]";

export const isEditableKeyboardTarget = (target: EventTarget | null) => {
  if (!(target instanceof HTMLElement)) return false;

  return (
    target instanceof HTMLInputElement ||
    target instanceof HTMLTextAreaElement ||
    target instanceof HTMLSelectElement ||
    target.isContentEditable ||
    target.closest("[contenteditable='true']") != null ||
    target.closest("[role='textbox']") != null ||
    target.closest(".monaco-editor") != null ||
    target.closest(".cm-editor") != null
  );
};

export const isDetailsSidebarToggleShortcut = (event: KeyboardEvent) => {
  const isRightBracket = event.code === "BracketRight" && !event.metaKey && !event.ctrlKey;
  const isShiftMetaB =
    event.shiftKey &&
    (event.metaKey || event.ctrlKey) &&
    !event.altKey &&
    event.key?.toLowerCase() === "b";

  return isRightBracket || isShiftMetaB;
};
